import Vue from '../lib/utils/vue3compat/vue.js?vue3';
import PerformancePlugin from '~/performance/vue_performance_plugin';
import initRepositoryPage from './init_repository_page.js?vue3';

Vue.use(PerformancePlugin, {
  components: ['SimpleViewer', 'BlobContent'],
});

export default function setupVueRepositoryList() {
  return initRepositoryPage();
}
